<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="550"
    [nzVisible]="isVisibleBadgeDrawer" [nzTitle]="badgeDrawerTitle" [nzFooter]="footerTpl"
    (nzOnClose)="handleCancel()">
    <form nz-form *nzDrawerContent [formGroup]="_fS.badgeForm">
        
        <div nz-row [nzGutter]="8">
            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="nameError">
                        <label class="label-text required">Badge name</label>
                        <input type="text" pattern="^(?!\s+$).+" 
                            class="input-group" nz-input formControlName="badgeName" maxlength="25" minlength="2">
                        <ng-template #nameError let-control>
                            <ng-container *ngIf="control.hasError('required')">Please enter badge name</ng-container>
                            <ng-container *ngIf="control.hasError('minlength')">Badge name {{validationMessage.minlength}}</ng-container>
                            <ng-container *ngIf="control.hasError('pattern')">Please enter badge name</ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
        <div nz-row [nzGutter]="15">
            <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="colorError">
                        <label class="label-text required">Color</label>
                        <div class=" d-flex align-i-c">
                            <div class="color picker-box d-flex align-i-c"
                                [ngStyle]="{'border': this.lightColorValidationColor=='INVALID' ? '1px solid red' : ''}">
                                <span class="color-name" [ngStyle]="{'background-color':lightColorStyle}"></span>
                                <input class="input-group color-input" nz-input formControlName="color"
                                    type="color" [(ngModel)]="lightColorStyle" (Change)="applyColorlightColor()" />
                                <span class="color-picker-icon"><img src="assets/images/color-picker-icon .svg"></span>
                            </div>
                        </div>
                        <ng-template #colorError let-control>
                            <ng-container *ngIf="control.hasError('required')">Please select color</ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
        <!-- </div> -->
        <!-- <div nz-row [nzGutter]="15"> -->
            <!-- <div nz-col nzSpan="16">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="colorError">
                        <label class="label-text required">Transaction Type</label>
                            <nz-select nzShowSearch nzPlaceHolder="Select badge type" [nzSize]="'default'"
                                formControlName="transactionType" [nzSelectOnTab]="true">
                                <nz-option [nzLabel]="'Investment'" [nzValue]="1"></nz-option>
                                <nz-option [nzLabel]="'Expenses'" [nzValue]="2"></nz-option>
                            </nz-select>
                        <ng-template #colorError let-control>
                            <ng-container *ngIf="control.hasError('required')">Please select transaction type</ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div> -->
        </div>
    </form>
    <ng-template #footerTpl>
        <div class="d-flex justify-content-end ">
            <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="isLoadingOne"
                class="medium-btn small-btn width-100 mr-1">{{selectedBadgeData != null ? 'Update' : 'Add'}}</button>
            <button nz-button nzType="default" (click)="handleCancel()"
                class="dlt-btn width-100">Cancel</button>
        </div>
    </ng-template>
</nz-drawer>